import { useSelector } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';

import { LogService } from '../services/log-service';
import Global from '../store/global-selectors';

/** @typedef {import('../pages/settings/payment-and-subscription/components/migrate-plan-modal/types').BillingPlan} BillingPlan */

/**
 * Searches several slices of Redux to find the seller's current `BillingPlan`, returns `emptyObject` if unable to find the billing plan
 * @returns {BillingPlan | {}}
 */
export const useGetCurrentBillingPlanWithFallbacks = () => {
  // preferred billingPlan
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { currentBillingPlan, allPlans } = subscriptionData || {};

  // first fallback is planInfo
  const planInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);
  const { plan: billingPlanFromPlanInfo, billingProviderID: billingProviderIdFromPlanInfo } = planInfo || {};

  // second fallback is to map billingPlanId to available plan in allPlans
  const billingPlanId = currentBillingPlan?.billingPlanId ?? billingProviderIdFromPlanInfo;
  const matchingBillingPlanFromAllPlans = allPlans?.find((billingPlan) => billingPlan.billingPlanId === billingPlanId);

  const foundBillingPlan = currentBillingPlan ?? billingPlanFromPlanInfo ?? matchingBillingPlanFromAllPlans;

  // return found billingPlan
  if (foundBillingPlan) {
    return foundBillingPlan;
  }

  // final fallback, return type-safe value
  LogService.logInfo('Unable to get billingPlan info for seller.', { billingPlanId });
  return emptyObject;
};
